export default {"src":"/_next/static/image/public/icons/instagram.17d3ae70ae131e978d73b9425808838b.svg","height":20,"width":20};